import { loggedInUser } from 'hooks/use-logged-in-user';
import { useConversationService } from 'hooks/services/use-conversation-service';
import { useQuery } from '@tanstack/react-query';
import { ITaskConversationType } from 'types';

interface ConversationTypesCache {
  conversationTypes: ITaskConversationType[];
  isConversationTypesLoading: boolean;
  hasConversationTypes: boolean;
}

export const useConversationTypesCache = (): ConversationTypesCache => {
  const conversationService = useConversationService();
  const { isLoggedIn } = loggedInUser.useController();

  const conversationTypeQuery = useQuery({
    queryKey: ['conversationTypes'],
    queryFn: () => conversationService.getConversationTypes(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isConversationTypesLoading, data: conversationTypes = [] } = conversationTypeQuery;

  return {
    isConversationTypesLoading,
    conversationTypes,
    hasConversationTypes: conversationTypes.length > 0
  };
};
